import { AppVersionTag } from '@components/AppVersionTag';
import { EnvironmentRibbon } from '@components/EnvironmentRibbon';
import { EnvironmentRibbonDemo } from '@components/EnvironmentRibbon/variations/EnvironmentRibbonDemo';
import { EnvironmentRibbonDev } from '@components/EnvironmentRibbon/variations/EnvironmentRibbonDev';
import type { ReactNode } from 'react';

type TIndicatorPanelProps = {
  children: ReactNode;
};

const IndicatorPanel = ({ children }: TIndicatorPanelProps) => (
  <div className="isolate relative h-32 overflow-hidden rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] p-4">
    {children}
  </div>
);

export const EnvironmentIndicatorsDemo = () => (
  <div className="grid gap-4 sm:grid-cols-2">
    <IndicatorPanel>
      <span className="text-xs font-medium text-[var(--color-text-muted)]">Version tag</span>
      <AppVersionTag version="v5.110 (abc1234)" className="!absolute !bottom-2 !right-2" />
    </IndicatorPanel>
    <IndicatorPanel>
      <span className="text-xs font-medium text-[var(--color-text-muted)]">Staging ribbon</span>
      <EnvironmentRibbon label="STAGING" className="absolute" />
    </IndicatorPanel>
    <IndicatorPanel>
      <span className="text-xs font-medium text-[var(--color-text-muted)]">Demo ribbon</span>
      <EnvironmentRibbonDemo label="DEMO" className="absolute" />
    </IndicatorPanel>
    <IndicatorPanel>
      <span className="text-xs font-medium text-[var(--color-text-muted)]">Dev ribbon</span>
      <EnvironmentRibbonDev label="DEV" className="absolute" />
    </IndicatorPanel>
  </div>
);
